<template>
  <el-autocomplete
    v-model="state"
    clearable
    class="el-list-input"
    popper-class="my-autocomplete"
    prefix-icon="el-icon-search"
    :fetch-suggestions="querySearch"
    :placeholder="placeholder"
    @select="handleSelect"
  >
    <template slot-scope="{ item }">
      <div class="name">{{ item.value }}</div>
      <span class="addr">{{ item.address }}</span>
    </template>
  </el-autocomplete>
</template>

<script>
export default {
  props: {
    communityList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      isAndroid: false,
      isIOS: false,
      placeholder: '请输入小区名称或地址',
      state: ''
    }
  },
  mounted() {},
  created() {},
  methods: {
    querySearch(queryString, cb) {
      const community = this.communityList
      const results = community.filter(this.createFilter(queryString))
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    judgeGlobalSearch(ctx, str) {
      const input = strCodeAt(str)
      const reg = new RegExp(input)
      if (reg.test(ctx)) {
        return true
      } else {
        return false
      }
      function strCodeAt(str) {
        const arr = str.split('')
        const result = arr.map((item) => {
          const judgeZh = /[\u4E00-\u9FA5|\u3002|\uFF1F|\uFF01|\uFF0C|\u3001|\uFF1B|\uFF1A|\u201C|\u201D|\u2018|\u2019|\uFF08|\uFF09|\u300A|\u300B|\u3008|\u3009|\u3010|\u3011|\u300E|\u300F|\u300C|\u300D|\uFE43|\uFE44|\u3014|\u3015|\u2026|\u2014|\uFF5E|\uFE4F|\uFFE5]/.test(
            item
          )
          const judgeEn = /[a-zA-Z]/.test(item)
          const judgeNum = /[0-9]/.test(item)
          if (judgeZh) {
            return '\\u' + item.charCodeAt().toString(16)
          } else if (judgeEn || judgeNum) {
            return item
          } else {
            return '\\' + item
          }
        })
        return result.join('')
      }
    },
    createFilter(queryString) {
      const vm = this
      if (
        queryString === null ||
        queryString === undefined ||
        queryString === ''
      ) {
        return () => {
          return false
        }
      }
      return (restaurant) => {
        return (
          vm.judgeGlobalSearch(restaurant.value, queryString) ||
          vm.judgeGlobalSearch(restaurant.address, queryString)
        )
      }
    },
    handleSelect(item) {
      this.$emit('move-to-target', item.id, item.value, item.district)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 901px) {
  .el-list-input {
    width: 100%;
    height: 100%;
    .el-input {
      input {
        height: 54px;
        line-height: 54px;
      }
    }
  }
  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }
  }
}

@media screen and (max-width: 901px) {
  .el-scrollbar {
    height: 100%;
  }
  .popper__arrow {
    display: none;
  }
  .el-autocomplete-suggestion__wrap {
    max-height: 100vh !important;
  }
  .el-autocomplete-suggestion {
    top: 47px !important;
    left: 0 !important;
    bottom: 2px !important;
    width: 100% !important;
  }
  .el-autocomplete {
    .el-input__prefix {
      left: 15px !important;
    }
    .el-input__suffix {
      right: 15px !important;
    }
  }

  .el-list-input {
    margin: 0 auto;
    width: 100%;
    height: 100%;
    .el-input {
      width: 100%;
      padding: 0px 10px;
      input {
        height: 40px;
        background: rgba(155, 155, 155, 0.1);
        border-radius: 20px;
        line-height: 40px;
      }
    }
  }
  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;
      border-bottom: 1px solid rgba(239, 241, 242, 1);
      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }
  }
}
</style>
